const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:5000').replace(/\/+$/, '')

export type HubName =
  | 'call'
  | 'chat'
  | 'notifications'
  | 'presence'
  | 'social'
  | 'stream'
  | 'wallet'
  | 'games'
  | 'admin'

/** SignalR hubs are mapped by the backend as `/hubs/<name>` (see LM.API Program.cs). */
export function hubUrl(name: HubName): string {
  return `${API_URL}/hubs/${name}`
}

/**
 * Passed as `accessTokenFactory`: SignalR calls it on every (re)connect handshake,
 * so it must read the current token instead of one captured when the hook mounted.
 */
export function hubAccessToken(): string {
  return localStorage.getItem('accessToken') ?? ''
}
